<template>
    <div class="page-root">
        <h2 class="name" @click="logTitleClick">
            <router-link
                :to="{
                        name: 'CAR_DATABASE',
                        query: {
                            key: 'code',
                            title: carSeriesInfo.brandName,
                            val: carSeriesInfo.brandId
                        }
                    }"
                target="_blank"
            >
                <img class="car-img" src="@/assets/images/bitmap-small.png" v-real-src="carSeriesInfo.brandLogo">
                <b>{{carSeriesInfo.name}}</b>
            </router-link>
        </h2>
        <!-- <c-tabs
            :tabs="pageTabs"
            :need-fixed="true"
            ref="tabs"
            @change="handleTabChange"
        /> -->
        <div class="tabs" ref="page-tabs">
            <div class="anchor-cover" :class="{'page-fixed': pageFixed}">
                <c-anchor
                    :params="pageTabs"
                    :first-top="true"
                    :top="79"
                    :refresh="refresh"
                    @clickitem="handleAnchor"
                />
            </div>
        </div>
        <div
            class="detail"
            data-type="anchor"
            data-anchor="index"
        >
            <div class="detail-img">
                <c-index-image
                    tab="大图"
                    :imgSrc="carSeriesInfo.displayCarImg && carSeriesInfo.displayCarImg.bigImg"
                    :carSeriesInfo="carSeriesInfo || {}"
                    :imageNumber="carPicNumber"
                />
                <div
                    v-if="carPicList.outer[0] && carPicList.outer[0].ThumbnailURL
                        && carPicList.inner[0] && carPicList.inner[0].ThumbnailURL
                        && carPicList.space[0] && carPicList.space[0].ThumbnailURL"
                    class="detail-img-more"
                >
                    <c-index-image
                        tab="外观"
                        :imgSrc="carPicList.outer[0] && carPicList.outer[0].ThumbnailURL"
                        :carSeriesInfo="carSeriesInfo || {}"
                    />
                    <c-index-image
                        tab="内饰"
                        :imgSrc="carPicList.inner[0] && carPicList.inner[0].ThumbnailURL"
                        :carSeriesInfo="carSeriesInfo || {}"
                    />
                    <c-index-image
                        tab="空间"
                        :imgSrc="carPicList.space[0] && carPicList.space[0].ThumbnailURL"
                        :carSeriesInfo="carSeriesInfo || {}"
                    />
                </div>
            </div>
            <div class="detail-info">
                <p class="detail-price">
                    经销商报价：
                    <span class="detail-price-seller">{{carSeriesInfo.dealerPrice}}</span>
                </p>
                <p class="detail-price">
                    厂商指导价：
                    <span class="detail-price-fact">{{carSeriesInfo.price}}</span>
                </p>
                <div class="detail-type">
                    <p>厂商：{{carSeriesInfo.manufacturerName}}</p>
                    <p>级别：{{carSeriesInfo.level}}</p>
                </div>
                <div v-if="carSeriesInfo.is_new_energy === '0'" class="detail-type">
                    <p>油耗：{{carSeriesInfo.engineFeature}}</p>
                    <p>排量：{{carSeriesInfo.engineLitersFormat}}</p>
                </div>
                <div v-if="carSeriesInfo.is_new_energy === '1'" class="detail-type">
                    <p>续航里程：{{carSeriesInfo.pure_engine_electromotor_cruising | paramParse('km')}}</p>
                    <p>快充：{{carSeriesInfo.engine_electromotor_fast_charging_time | paramParse('h')}}</p>
                </div>
                <div class="detail-btn-group" v-if="carSeriesInfo.id">
                    <router-link
                        v-if="+carSeriesInfo.has_series_config"
                        class="link-to-param"
                        :to="{
                            name: 'PARAMETER',
                            params: {
                                serid: carSeriesInfo.id
                            }
                        }"
                        @click.native="logIndexParams"
                        target="_blank"
                    >参数配置</router-link>
                    <el-tooltip
                        v-if="bigphone"
                        :content="'免费咨询: ' + bigphone"
                        placement="bottom-start"
                        popper-class="c-tooltips"
                        effect="light"
                    >
                        <div
                            class="get-price-big free-phone"
                            data-key="car_train_dealer_phone_show"
                            @click="handleMouseEnter('click')"
                            @mouseenter="handleMouseEnter('hover')"
                        >
                            <i class="c-icon">&#xe600;</i>
                            <span>免费咨询</span>
                        </div>
                    </el-tooltip>
                    <router-link
                        class="get-price-big"
                        :to="{
                            name: 'ASK_PRICE',
                            query: {
                                fromPage: `${$route.path}@car_train_index_askPrice_click`
                            },
                            params: {
                                serid: carSeriesInfo.id
                            }
                        }"
                        :data-key="'index_' + carSeriesInfo.id"
                        @click.native="logIndexAskPrice"
                        target="_blank"
                    >获取底价</router-link>
                </div>
            </div>
        </div>
        <div class="all"
            data-type="anchor"
            data-anchor="carlist"
        >
            <div class="all-content"
                ref="all-content"
                :style="{height: watchMore || (tabContent[currentTab] && tabContent[currentTab].length) <= 6 ? 'auto' : '375px'}"
            >
                <el-tabs @tab-click="handleClick">
                    <el-tab-pane
                        v-for="(item, idx) in tabPane"
                        :label="item.name"
                        :key="item.name"
                    >
                        <c-carlist
                            :contrast-list="contrastList"
                            :carSeriesInfo="carSeriesInfo || {}"
                            :carData="tabContent[idx] || []"
                            :tabpane="item.name"
                            @addcontrast="handleAddContrast"
                            @sendlog="sendLog"
                            @sendUbcLog="sendUbcLog"
                        ></c-carlist>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div class="all-more" v-if="tabContent[currentTab] && tabContent[currentTab].length > 6">
                <span @click="handleWatchMore"><span>{{watchMore ? '收起' : '查看更多'}}</span><i class="c-icon" :class="{isActive: watchMore}">&#xe60f;</i></span>
            </div>
        </div>
        <div
            v-if="carPicList.outer.length
                || carPicList.inner.length
                || carPicList.space.length"
            class="imgs"
            data-type="anchor"
            data-anchor="realpic"
        >
            <h3 class="title">实拍图片</h3>
            <c-img-list
                v-if="carPicList.outer.length"
                tab="外观"
                :imgList="carPicList.outer || []"
                :carSeriesInfo="carSeriesInfo || {}"
            />
            <c-img-list
                v-if="carPicList.inner.length"
                tab="内饰"
                :imgList="carPicList.inner || []"
                :carSeriesInfo="carSeriesInfo || {}"
            />
            <c-img-list
                v-if="carPicList.space.length"
                tab="空间"
                :imgList="carPicList.space || []"
                :carSeriesInfo="carSeriesInfo || {}"
            />
        </div>
        <!-- 官方图 -->
        <div
            v-if="carPicList.offical.length >= 7"
            class="offical-imgs"
            data-type="anchor"
            data-anchor="officalpic"
        >
            <h3 class="title">
                <p class="title-h3">官方图片</p>
                <router-link
                    class="title-more"
                    :to="{
                        name: 'IMAGE_LIST',
                        query: {
                            sername: carSeriesInfo.name,
                            tab: '官方图'
                        },
                        params: {
                            serid: carSeriesInfo.id
                        }
                    }"
                    target="_blank"
                    @click.native="handleLog('offical', 'watchMore')"
                >
                    查看更多
                    <i class="el-icon-arrow-right"></i>
                </router-link>
            </h3>
            <div class="offical-content">
                <router-link
                    class="offical-big-img"
                    :to="{
                        name: 'IMAGE_DETAIL',
                        query: {
                            sername: carSeriesInfo.name,
                            tab: '官方图',
                            index: 0
                        },
                        params: {
                            serid: carSeriesInfo.id
                        }
                    }"
                    target="_blank"
                >
                    <img
                        src="@/assets/images/bitmap-small.png"
                        v-real-src="carPicList.offical[0].ThumbnailURL"
                        @click="logImgVideoClick('offical', 0)"
                    >
                </router-link>
                <div class="offical-others">
                    <template v-for="(item, idx) in carPicList.offical">
                        <router-link
                            v-if="idx !== 0"
                            :key="item.ThumbnailURL"
                            :to="{
                                name: 'IMAGE_DETAIL',
                                query: {
                                    sername: carSeriesInfo.name,
                                    tab: '官方图',
                                    index: item.ImageIndexNumber - 1
                                },
                                params: {
                                    serid: carSeriesInfo.id
                                }
                            }"
                            target="_blank"
                        >
                            <img
                                :key="item.ThumbnailURL"
                                src="@/assets/images/bitmap-small.png"
                                v-real-src="item.ThumbnailURL"
                                @click="logImgVideoClick('offical', idx)"
                            />
                        </router-link>
                    </template>
                </div>
            </div>
        </div>
        <c-reputation
            :seriesId="query.series_id"
            :seriesName="query.series_name"
            @getdatastatus="getdatastatus"
        />
        <!-- 视频说明书 -->
        <div
            class="offical-imgs video-intro"
            v-if="videoList.length >= 7"
            data-type="anchor"
            data-anchor="videointro"
        >
            <h3 class="title">
                <p class="title-h3">视频说明书</p>
                <router-link
                    class="title-more"
                    :to="{
                        name: 'VIDEO_INTRO',
                        query: {
                            sername: carSeriesInfo.name,
                        },
                        params: {
                            serid: carSeriesInfo.id
                        }
                    }"
                    target="_blank"
                    @click.native="handleLog('video', 'watchMore')"
                >
                    查看更多
                    <i class="el-icon-arrow-right"></i>
                </router-link>
            </h3>
            <div class="offical-content">
                <router-link
                    class="offical-big-img"
                    :to="{
                        name: 'VIDEO_INTRO',
                        query: {
                            sername: carSeriesInfo.name,
                        },
                        params: {
                            serid: carSeriesInfo.id
                        }
                    }"
                    target="_blank"
                >
                    <img
                        src="@/assets/images/bitmap-small.png"
                        v-real-src="videoList[0].image_url"
                        @click="logImgVideoClick('video', 0)"
                    >
                    <p class="img-name">{{videoList[0].name}}</p>
                </router-link>
                <div class="offical-others">
                    <template v-for="(item, idx) in videoList">
                        <router-link
                            v-if="idx !== 0"
                            :key="idx"
                            :to="{
                                name: 'VIDEO_INTRO',
                                query: {
                                    sername: carSeriesInfo.name,
                                    tab: item.parentName,
                                    index: item.index
                                },
                                params: {
                                    serid: carSeriesInfo.id
                                }
                            }"
                            target="_blank"
                        >
                            <img
                                :key="item.ThumbnailURL"
                                src="@/assets/images/bitmap-small.png"
                                v-real-src="item.image_url"
                                @click="logImgVideoClick('video', idx)"
                            />
                            <p class="img-name">{{item.name}}</p>
                        </router-link>
                    </template>
                </div>
            </div>
        </div>
        <c-guide
            :series-id="query.series_id"
            @change="handleGuideopen"
            @getdatastatus="getdatastatus"
        />
        <c-contrast-class
            :series-id="query.series_id"
            @getdatastatus="getdatastatus"
        />
        <c-feeds
            :carInfoSimple="carInfoSimple"
            :urlParams="query || {}"
            :carSeriesInfo="carSeriesInfo || {}"
            @getdatastatus="getdatastatus"
        />
        <c-contrast
            page-name="car_train"
            :contrast-list="contrastList"
            @addcontrast="handleAddContrast"
        />
        <c-scroll-top :no-qrcode="true" />
    </div>
</template>

<script>
/**
 * @file
 * @author guozhihao02
 */
import request from 'http/request';
import URLS from 'http/URLS';
import {sendLog, inSightObserver, inSightObserverDisconnect, bandSdk} from 'js/log';
import {get, isEmpty} from 'lodash';
import {mapGetters} from 'vuex';
import {on, off, scrollTop} from 'js/Utils';
import {random} from 'js/core';
import {sendUbcLog} from 'js/ubclog';
import mixinLog from '@/mixin/log.js';
import {parseTabs} from './parseData';
import carList from './car-list';
import IndexImg from './index-img';
import ImgList from './img-list';
import Feeds from './feeds';
import scrollTopCom from 'components/scroll-top';
import Contrast from 'components/contrast';
// import Tabs from 'components/tabs';
import Anchor from 'components/anchor';
import Reputation from './reputation';
import ContrastClass from './contrast-class';
import Guide from './guide';

const REQUESTING = {};

export default {
    mixins: [mixinLog],
    props: {
        serid: String
    },
    data() {
        return {
            pageTabs: [],
            pageFixed: false,
            carSeriesInfo: {},
            carPicList: {
                outer: [],
                inner: [],
                space: [],
                offical: []
            },
            carPicNumber: 0,
            videoList: [],
            currentTab: '',
            watchMore: false,
            // currentPage: 1,
            tabPane: [],
            tabContent: [],
            carInfoSimple: {},
            query: {},
            contrastList: [],
            refresh: +new Date(),
            bigphone: '', // 最上面的电话
            ubcOptions: {}
        };
    },
    components: {
        'c-carlist': carList,
        'c-scroll-top': scrollTopCom,
        'c-index-image': IndexImg,
        'c-img-list': ImgList,
        'c-feeds': Feeds,
        'c-reputation': Reputation,
        'c-contrast': Contrast,
        'c-contrast-class': ContrastClass,
        // 'c-tabs': Tabs
        'c-anchor': Anchor,
        'c-guide': Guide
    },
    filters: {
        paramParse(val, unit) {
            return !val ? '暂无' : `${val}${unit}`;
        }
    },
    mounted() {
        let query = this.$route.query || {};
        this.query = {
            'series_id': this.serid,
            'series_name': query.seriesName
        };

        // 兼容低版本路由
        if (query.seriesId && !this.serid) {
            this.query.series_id = query.seriesId; // eslint-disable-line
        }
        this.$nextTick(() => {
            this.sendUbcLog(undefined, undefined, this.query);
        });

        this.init();
    },
    computed: {
        ...mapGetters({
            location: 'location'
        })
    },
    watch: {
        '$store.state.location.cityName'() {
            this.init(true);
        }
    },
    activated() {
        on(window, 'scroll', this.handleScroll);
    },
    deactivated() {
        off(window, 'scroll', this.handleScroll);
    },
    beforeDestroy() {
        off(window, 'scroll', this.handleScroll);
        inSightObserverDisconnect();
    },
    methods: {
        init(cityChange = false) {
            this.$nextTick(async () => {
                await this.getseriesinfo();
                await this.getSeriesModel(undefined, {}, true);
                this.getSeriesDealer();

                // 图片不需要重新拉取
                if (!cityChange) {
                    // 不得不说后端真秀
                    Promise.all([
                        this.getcarpiclist('外观', 'outer'),
                        this.getcarpiclist('内饰', 'inner'),
                        this.getcarpiclist('空间', 'space'),
                        this.getcarpiclist('官方图', 'offical', 7)
                    ])
                        .then(res => {
                            this.carPicNumber = res.reduce((p, n) => p + n, 0);
                        });
                    this.getcarpiclistVideo('视频说明书');
                    // 官方图不参与计算
                }
            });
        },
        getseriesinfo() {
            const param = {
                ...this.query,
                city: this.location.cityName || ''
            };
            request(URLS.GETSERIESINFO,
                param,
                {method: 'get'}
            )
                .then(res => {
                    const Result = res.Result;
                    // 处理默认数据
                    Result.engineLitersFormat = Result.engineLiters && Array.isArray(Result.engineLiters)
                        ? Result.engineLiters.join(' / ')
                        : '暂无';
                    Result.dealerPrice = Result.dealerPrice || '暂无报价';
                    Result.price = Result.price || '暂无报价';
                    if (Result.level) {
                        Result.level = String(Result.level).toUpperCase();
                    } else {
                        Result.level = '其他';
                    }
                    if (Result.engineFeature === '') {
                        Result.engineFeature = '暂无';
                    }
                    this.carSeriesInfo = Result;
                    this.carInfoSimple = {
                        name: Result.name || '',
                        brandName: Result.brandName || '',
                        seriesId: Result.id || ''
                    };

                    this.$nextTick(() => {
                        inSightObserver(
                            '.get-price-big',
                            'car_train_index_askprice_show',
                            {
                                seriesId: this.query.series_id,
                                seriesName: this.query.series_name
                            },
                            undefined,
                            { // ubc 打点参数
                                log: true,
                                name: 'clue_form',
                                id: '11435',
                                options: {
                                    ...this.ubcOptions,
                                    ext: {
                                        ...(this.ubcOptions.ext || {}),
                                        area: 'car_train_index_askPrice_click'
                                    },
                                    type: 'show'
                                }
                            }
                        );
                    });
                })
                .catch(() => {
                    // TODO
                });
        },
        getSeriesModel(idx = 0, condition = {}, first) {
            if (condition) {
                // 如果在请求中，或者已经请求到了数据，无需再次请求
                if (REQUESTING[idx] || this.tabContent[idx]) {
                    return;
                }
                // 此处采用同步设置
                REQUESTING[idx] = true;
            }
            /* eslint-disable fecs-camelcase */
            const param = {
                ...this.query,
                city: this.location.cityName || '',
                ...condition
            };
             /* eslint-enable fecs-camelcase */
            return request(URLS.GETSERIESMODEL,
                param,
                {method: 'get'}
            )
                .then(res => {
                    const {modelList = [], modelTabs = []} = res.Result;
                    if (!this.tabPane.length) {
                        this.tabPane = modelTabs;
                        this.currentTab = this.currentTab || 0;
                    }
                    if (modelList && modelList.length) {
                        const tData = modelList.reduce((p, n) => {
                            return (n.data || []).reduce((p1, n1) => {
                                return [
                                    ...p1,
                                    {
                                        keyName: n1.name === '其他' ? '车型' : n1.name,
                                        key: `${n.type}_${n1.name}`
                                    },
                                    ...(n1.models || [])
                                ];
                            }, p);
                        }, []);
                        this.$set(this.tabContent, idx, tData);
                    }

                    REQUESTING[idx] = false;
                    // 只有第一次才去拉取其他的数据
                    if (first) {
                        this.calcAskPriceWidth(0);
                        this.$nextTick(() => {
                            this.recursionGetTabData(modelTabs);

                            // 监测第一个tab的按钮展现
                            this.inSightObserverTab(modelTabs[this.currentTab].name);
                        });
                    }
                })
                .catch(err => {
                    REQUESTING[idx] = false;
                });
        },
        getcarpiclist(tagName, name, rn = 5) {
            return request(URLS.GETCARPICLIST, {
                ...this.query,
                'tag_name': tagName,
                pn: 1,
                rn
            }, {method: 'get'})
                .then(res => {
                    const Result = res.Result || {};
                    this.carPicList = {
                        ...this.carPicList,
                        [name]: get(Result, 'lists.list', [])
                    };
                    if (tagName === '官方图') {
                        this.pageTabs = parseTabs('官方图片', get(Result, 'lists.list', []).length >= 7);
                    }
                    else {
                        this.pageTabs = parseTabs('实拍图片', get(Result, 'lists.list', []).length > 0);
                    }
                    return Promise.resolve(Result.total || 0);
                })
                .catch(() => {
                    if (tagName === '官方图') {
                        this.pageTabs = parseTabs('官方图片', false);
                    }
                    else {
                        this.pageTabs = parseTabs('实拍图片', false);
                    }
                });
        },
        getcarpiclistVideo(tagName) {
            request(URLS.GETCARPICLIST, {
                ...this.query,
                'tag_name': tagName
            })
                .then(res => {
                    // console.log(res, 'video')
                    const videoList = get(res, 'Result.instructions[0].category1[0].category2', []);
                    let tmpList = [];
                    videoList.forEach((val, idx) => {
                        if (tmpList.length >= 7) {
                            return;
                        }
                        else if (idx === 0 && val.name === '完整视频') {
                            tmpList.push(val.tag[0]);
                        }
                        else {
                            let end = 2;
                            // 最后排用于补齐 7 个
                            if (idx === videoList.length - 1) {
                                end = 7 - tmpList.length;
                            }
                            const tmp = val.tag.slice(0, end);
                            tmp.forEach((v, i) => {
                                v.parentName = val.name;
                                v.index = i;
                            });
                            tmpList.push(...tmp);
                        }
                    });
                    if (tmpList.length === 7) {
                        this.videoList = tmpList;

                        // 视频说明书
                        this.pageTabs = parseTabs('视频说明书', true);
                    }
                })
                .catch(err => {
                    this.pageTabs = parseTabs('视频说明书', false);
                });
        },
        // 递归的获取所有的 tab 数据
        async recursionGetTabData(list) {
            for (let i = 0; i < list.length; i++) {
                await this.getSeriesModel(i, list[i].conditions);
            }
        },
        getSeriesDealer() {
            /* eslint-disable fecs-camelcase */
            request(URLS.getSeriesDealer, {
                series_id: this.query.series_id,
                query: this.query.series_name,
                city: this.location.cityName,
                geo: this.location.lat && this.location.long
                    ? `${this.location.lat}_${this.location.long}` : 0
            })
                .then(res => {
                    const dealer = get(res.Result, 'dealer', [])
                        .map(v => get(v, 'clue_info_list.clue_phone.mid_clue_id', undefined))
                        .filter(v => v);
                    if (dealer.length) {
                        bandSdk.clue.getPhone({
                            id: dealer[random(0, dealer.length - 1)]
                        }).then(res => {
                            this.bigphone = res.phone;
                            setTimeout(() => {
                                inSightObserver(
                                    '.free-phone',
                                    'car_train_index_phone_show',
                                    {
                                        seriesId: this.query.series_id,
                                        seriesName: this.query.series_name
                                    },
                                    undefined,
                                    { // ubc 打点参数
                                        log: true,
                                        name: 'clue_phone',
                                        id: '11435',
                                        options: {
                                            ...this.ubcOptions,
                                            ext: {
                                                ...(this.ubcOptions.ext || {}),
                                                area: 'car_train_index_phone_click'
                                            },
                                            type: 'show'
                                        }
                                    }
                                );
                            }, 1000);
                        })
                            .catch(e => {
                                console.log(e, 'e'); // eslint-disable-line
                            });
                    }
                })
                .catch(err => {
                    console.log(err);
                });
            /* eslint-enable fecs-camelcase */
        },
        handleClick(e) {
            const {paneName, index} = e;
            const tab = this.tabPane[paneName];
            this.currentTab = paneName;
            if (isEmpty(this.tabContent[paneName])) {
                this.getSeriesModel(index, tab.conditions);
            }
            this.sendLog('change_tabpane', {
                tab: tab.name
            });
            this.calcAskPriceWidth(index);

            // 如果切换了tab，需要重新监测一下新数据
            this.inSightObserverTab(tab.name);
        },
        inSightObserverTab(tab) {
            this.$nextTick(() => {
                inSightObserver(
                    '.list-info .btn-askprice',
                    'car_train_list_askprice_show',
                    {
                        seriesId: this.query.series_id,
                        seriesName: this.query.series_name,
                        tab: tab.name
                    },
                    ['modelId', 'modelName', 'pos'],
                    { // ubc 打点参数
                        log: true,
                        name: 'clue_form',
                        id: '11435',
                        options: {
                            ...this.ubcOptions,
                            ext: {
                                ...(this.ubcOptions.ext || {}),
                                area: 'car_train_askPrice_click'
                            },
                            type: 'show'
                        }
                    }
                );
            });
        },
        handleWatchMore() {
            this.watchMore = !this.watchMore;
            this.sendLog('watch_more_click', {
                tab: this.tabPane[this.currentTab].name,
                status: this.watchMore ? '展开' : '折叠'
            });
            this.$nextTick(() => {
                this.refresh = +new Date();
                if (!this.watchMore) {
                    scrollTop(
                        window,
                        document.documentElement.scrollTop
                            || document.body.scrollTop,
                        this.$refs['all-content'].offsetTop - 79
                    );
                }
            });
        },
        handleAddContrast(item, type) {
            if (type === 'del') {
                this.contrastList = this.contrastList
                    .filter(v => v.id !== item.id);
                return;
            }
            else if (type === 'update') {
                this.contrastList = item;
                return;
            }

            if (!Array.isArray(item)) {
                item = [item];
            }
            const tmpArr = [];
            item.forEach(val => {
                if (!this.contrastList.find(v => v.id === val.id)) {
                    tmpArr.unshift(val);
                }
            });
            this.contrastList = [...tmpArr, ...this.contrastList];
        },
        handleScroll() {
            const {offsetTop} = this.$refs['page-tabs'];
            let scrollY = window.pageYOffset
                    || document.documentElement.scrollTop
                    || document.body.scrollTop;
            if (offsetTop - scrollY <= 0) {
                this.pageFixed = true;
            }
            else {
                this.pageFixed = false;
            }
        },
        handleAnchor(item, pos) {
            this.sendLog('anchor_click', {
                pos,
                tabName: item.itemName
            });
        },
        handleGuideopen() {
            this.$nextTick(() => {
                // 动画时长200ms
                setTimeout(() => {
                    this.refresh = +new Date();
                }, 250);
            });
            this.sendLog('guide_watch_more');
        },
        getdatastatus(name, status) {
            if (name === 'reputation') {
                this.pageTabs = parseTabs('车主口碑', status);
            }
            else if (name === 'contrastclass') {
                this.pageTabs = parseTabs('同级对比', status);
            }
            else if (name === 'feeds') {
                this.pageTabs = parseTabs('精彩资讯', status);
            }
            else if (name === 'guide') {
                this.pageTabs = parseTabs('测评报告', status);
            }
        },
        calcAskPriceWidth(index) {
            this.$nextTick(() => {
                const element = [...document.querySelectorAll(`#pane-${index} .real-price`)];
                const maxWidth = element.reduce((p, n) => Math.max(p, n.offsetWidth), 82);
                if (maxWidth <= 82) {
                    return;
                }
                element.forEach(ele => ele.style.width = maxWidth + 'px');
            });
        },
        routerParse(item) {
            if (item.contentType === 2) {
                return {
                    name: 'VIDEO_DETAIL',
                    query: {
                        serid: this.carSeriesInfo.id,
                        sername: this.carSeriesInfo.name
                    },
                    param: {
                        nid: item.nid
                    }
                };
            }
            else if (item.contentType === 1) {
                return {
                    name: 'ARTICLE_DETAIL',
                    query: {
                        serid: this.carSeriesInfo.id,
                        sername: this.carSeriesInfo.name
                    },
                    params: {
                        nid: item.nid
                    }
                };
            }
            // 直接跳转到提供的地址
            else {
                return item.url;
            }
        },
        handleMouseEnter(type) {
            this.sendLog('index_phone_click', {
                action: type
            });
            this.sendUbcLog('clue_phone', {ext: {area: 'car_train_index_phone_click'}});
        },
        logTitleClick() {

        },
        logIndexAskPrice() {
            /* eslint-disable fecs-camelcase */
            this.sendLog('index_askPrice_click', {
                price_url: this.carSeriesInfo.askPriceWiseUrl
            });
            sessionStorage.setItem('YOUJIA_SESSION_askPriceArea', 'car_train_index_askPrice_click');
            this.sendUbcLog('clue_form', {ext: {area: 'car_train_index_askPrice_click'}});
            /* eslint-enable fecs-camelcase */
        },
        logFeedsClick(item) {
            this.sendLog('feeds_click', {
                nid: item.nid,
                type: +item.contentType === 1
                    ? '图文' : +item.contentType === 2
                    ? '视频' : '其他'
            });
        },
        logIndexParams() {
            this.sendLog('index_params_click');
        },
        logImgVideoClick(type, pos) {
            if (type === 'offical') {
                this.sendLog('image_click', {
                    tab: '官方图',
                    pos
                });
            }
            else if (type === 'video') {
                this.sendLog('video_intro_click', {
                    tab: '视频说明书',
                    pos
                });
            }
        },
        handleLog(type) {
            if (type === 'offical') {
                this.sendLog('image_click_more', {
                    tab: '官方图'
                });
            }
            else if (type === 'video') {
                this.sendLog('video_intro_more', {
                    tab: '视频说明书'
                });
            }
        },
        sendLog(key, params) {
            sendLog(`car_train_${key}`, {
                ...this.carInfoSimple,
                ...(params || {})
            });
        },
        sendUbcLog(name, options = {}, seriesInfo) {
            /* eslint-disable fecs-camelcase */
            if (seriesInfo) {
                this.ubcOptions = {
                    page: '/view/carTrain',
                    ext: {
                        client: 'pc',
                        train_id: seriesInfo.series_id,
                        train_name: seriesInfo.series_name,
                        city: this.location.cityName,
                        ...(options.ext || {})
                    }
                };
                return;
            }
            const ext = {
                ...(this.ubcOptions.ext || {}),
                ...(options.ext || {})
            };
            sessionStorage.setItem('YOUJIA_SESSION_ASK_PRICE_BTN', JSON.stringify(ext));
            sendUbcLog('11435', 'event', {
                value: name,
                type: options.type || 'clk',
                ...this.ubcOptions,
                ...options,
                ext: {
                    ...(this.ubcOptions.ext || {}),
                    ...(options.ext || {})
                }
            });
            /* eslint-enable fecs-camelcase */
        }
    }
};
</script>

<style lang="less">
.c-tooltips {
    width: 192px;
    height: 42px;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    color: #666666!important;
    border-color: #FFF!important;
    box-shadow: 0 1px 8px 0 rgba(0,0,0,.15);
    &[x-placement^='bottom'] {
        .popper__arrow {
            border-bottom-color: #FFFFff!important;
        }
    }
}
</style>

<style lang="less" scoped>
@themeColor: #00CECF;

.page-root {
    width: 1200px;
    min-height: 100%;
    margin: 0 auto;
    padding-bottom: 80px;
}
img {
    display: block;
}
.name {
    font-size: 36px;
    width: 100%;
    letter-spacing: 0;
    margin-top: 36px;
    height: 50px;
    a {
        display: inline-block;
        color: #333333;
        align-items: center;
        overflow: hidden;
    }
    b {
        float: left;
        line-height: 50px;
    }
    img {
        float: left;
        display: inline-block;
        height: 50px;
        margin-right: 6px;
    }
}
.tabs {
    height: 66px;
    border-bottom: 1px solid #EEEEEE;
    .anchor-cover {
        width: 100%;
        top: 0;
        left: 0;
        z-index: 99;
        &.page-fixed {
            position: fixed;
            box-shadow: 0 6px 8px 0 rgba(0,0,0,.02);
        }
    }
    /deep/ .anchor {
        display: flex;
        width: 1200px;
        margin: 0 auto;
        height: 65px;
        line-height: 67px;
        font-size: 20px;
        color: #666666;
        background: #FFFFFF;
        > div {
            position: relative;
            margin-left: 32px;
            cursor: pointer;
            &:first-child {
                margin-left: 0;
            }
            &::after {
                content: '';
                position: absolute;
                opacity: 0;
                width: 8px;
                height: 8px;
                right: -9px;
                top: 20px;
                transition: opacity .1s linear;
                background: url(../../common/images/index/tab-circle.svg) no-repeat;
            }
        }
        .anchorActive {
            font-weight: 500;
            color: #333333;
            &::after {
                opacity: 1;
            }
        }
    }
}
/deep/ .vertical-letter {
    display: flex;
    justify-content: center;
    align-items: center;
    span {
        writing-mode: vertical-lr;
        letter-spacing: 6px;
        padding-top: 6px;
        // line-height: 22px;
    }
    &.vertical-letter-icon {
        flex-direction: column;
    }
    &.more {
        color: #999999!important;
        cursor: pointer;
    }
}
.detail {
    display: flex;
    margin-top: 35px;
    height: 264px;
    .detail-img {
        display: flex;
    }
    .detail-img-more {
        display: flex;
        width: 147px;
        margin-left: 9px;
        flex-direction: column;
        justify-content: space-between;
    }
    .detail-info {
        margin-left: 36px;
        .detail-price {
            display: flex;
            align-items: center;
            font-size: 16px;
            line-height: 16px;
            color: #666666;
            span.detail-price-seller {
                font-size: 24px;
                line-height: 24px;
                color: #FF6F61;
            }
            span.detail-price-fact {
                color: #151515;
            }
            &:first-child {
                margin-top: 30px;
            }
            &:nth-child(2) {
                margin-top: 20px;
            }
        }
        .detail-type {
            display: flex;
            margin-top: 24px;
            font-size: 16px;
            line-height: 16px;
            color: #666666;
            p {
                width: 246px;
            }
        }
    }
    .detail-btn-group {
        margin-top: 30px;
        font-size: 16px;
        text-align: center;
        line-height: 42px;
    }
    .get-price-big {
        float: left;
        display: block;
        width: 158px;
        height: 42px;
        border-radius: 3px;
        color: #FFFFFF;
        background: @themeColor;
        cursor: pointer;
    }
    .free-phone {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 16px;
        .c-icon {
            font-size: 18px;
            margin-right: 2px;
        }
    }
    .link-to-param {
        float: left;
        display: block;
        width: 158px;
        height: 42px;
        margin-right: 16px;
        border-radius: 3px;
        color: #333333;
        border: 1px solid #666666;
        cursor: pointer;
    }
}
.all {
    margin-top: 42px;
    .all-content {
        overflow: hidden;
    }
    .all-more {
        margin-top: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        line-height: 16px;
        color: #666666;
        cursor: pointer;
        >span {
            display: inline-block;
        }
        i {
            display: inline-block;
            margin-left: 9px;
            &.isActive {
                transform: rotate(-180deg);
            }
        }
    }
    /deep/ .el-tabs__nav-prev,
    /deep/ .el-tabs__nav-next {
        font-size: 20px;
        line-height: 20px;
    }
}
.offical-imgs {
    .offical-content {
        padding-top: 12px;
        border-top: 1px solid #EEEEEE;
        display: flex;
        img {
            display: block;
        }
        .offical-big-img {
            position: relative;
            img {
                width: 485px;
                height: 323px;
            }
        }
        .offical-others {
            display: flex;
            flex-wrap: wrap;
            align-content: space-between;
            margin-left: 9px;
            a {
                position: relative;
                margin-left: 9px;
                &:nth-child(3n + 1) {
                    margin-left: 0;
                }
            }
            img {
                width: 229px;
                height: 153px;
            }
        }
        .img-name {
            position: absolute;
            width: 100%;
            height: 32px;
            font-size: 14px;
            line-height: 34px;
            text-align: center;
            bottom: 0;
            color: #FFFFFF;
            background: rgba(0, 0, 0, .40);
        }
    }
}
.video-intro {
    .offical-content {
        .offical-big-img {
            img {
                height: 273px;
            }
        }
        .offical-others {
            img {
                height: 129px;
            }
        }
    }
}
/deep/ .title {
    font-size: 20px;
    line-height: 20px;
    margin: 42px 0 24px;
    color: #333333;
    overflow: hidden;
    .title-h3 {
        float: left;
    }
    .title-more {
        float: right;
        font-size: 16px;
        color: #666666;
        font-weight: 400;
    }
}
/deep/ .all {
    .el-tabs__item {
        position: relative;
        font-size: 20px;
        line-height: 20px;
        color: #666666;
        font-weight: normal;
        &::after {
            content: '';
            opacity: 0;
            position: absolute;
            width: 8px;
            height: 8px;
            top: -4px;
            right: 11px;
            background-image: url(../../common/images/index/tab-circle.svg);
            background-repeat: no-repeat;
            background-size: 100% 100%;
            transition: opacity .1s linear;
        }
        &:last-child {
            &::after {
                right: -9px;
            }
        }
    }
    .is-active {
        font-weight: 500;
        color: #333333;
        &::after {
            opacity: 1;
        }
    }
    .el-tabs__nav-wrap {
        padding-top: 5px;
        &::after {
            height: 1px;
            background: #E6E6E6;
        }
    }
    .el-tabs__nav-scroll {
        padding-top: 5px;
        margin-top: -5px;
    }
    .el-tabs__active-bar {
        display: none;
    }
    .el-tabs__header {
        margin-bottom: 21px;
    }
}
</style>
